'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var browserVersions = exports.browserVersions = require('../../data/browserVersions');


//////////////////
// WEBPACK FOOTER
// ./~/caniuse-lite/dist/unpacker/browserVersions.js
// module id = 262
// module chunks = 0